import { CircularProgress, Typography } from "@mui/material";
import { ResponsiveRow } from "../../../constants/layout.constants";
import RecommendedListing from "../../cards/listings/recommendedListing";
import { useEffect, useState } from "react";
import { isNullUndefined, tryParseFloat } from "../../../util/util";
import { useNavigate } from "react-router-dom";
import { getFeaturedListings } from "../../../services/listingsServices/listing.service";

export default function ListingFeaturedListings({location}) {
    const [listings, setListings] = useState([]);
    const [loading, setLoading ] = useState(false);
    const navigator = useNavigate();

    const handleView = (listing) => {
        navigator(`/listings/view/${listing.id}`);
    };

    useEffect(() => {
        // Fetch immediately on mount
        const fetchListings = async () => {
            setLoading(true);
            const data = location?.lat && location?.lon
                ? {
                    lat: tryParseFloat(location?.lat),
                    lon: tryParseFloat(location?.lon),
                }
                : {};
            const response = await getFeaturedListings(data);
            if (!isNullUndefined(response)) {
                setListings(response);
            }
            setLoading(false);
        };
        fetchListings();

        // Set up interval for periodic refresh
        const interval = setInterval(fetchListings, 600000); // 10 minutes
        return () => clearInterval(interval);
    }, [location?.lat, location?.lon]);

    return (
        <ResponsiveRow
            container
            sx={{
                flexDirection: "column",
                textAlign: "start",
                padding: "20px",
                margin: "auto",
                width: { xs: "100%", lg: "80%" },
                marginTop: "20px",
            }}
        >
            <Typography variant="h1">Featured Listings</Typography>

            <ResponsiveRow sx={{ padding: { xs: "10px", lg: "20px" } }}>
                <ResponsiveRow sx={{ flexWrap: "wrap" }}>
                    {loading ? (
                        <CircularProgress />
                    ) : listings.length === 0 ? (
                        <Typography variant="body1" sx={{ color: "text.secondary" }}>
                            No featured listings available.
                        </Typography>
                    ) : (
                        listings.map((listing) => (
                            <RecommendedListing listing={listing} handleView={handleView} key={listing.id} />
                        ))
                    )}
                </ResponsiveRow>
            </ResponsiveRow>
        </ResponsiveRow>
    );
}
